import { Theme } from '@nexelem/deprecated-theme';

export const getCell = (theme: Theme) => {
  return {
    '.MuiDataGrid-cell': {
      border: 'none',
      outline: 'none',
      padding: '0px 8px',
      '&:focus': {
        outline: 'none',
      },
      '&:focus-within': {
        outline: 'none',
      },
      '&.MuiDataGrid-cell--withRightBorder.MuiDataGrid-cell--pinnedLeft': {
        //TODO: remove getColor
        borderRight: `1px solid ${theme.palette.getColor(theme.client.table.common.border)}`,
      },
      '&.MuiDataGrid-cell--withLeftBorder.MuiDataGrid-cell--pinnedRight': {
        borderLeft: `1px solid ${theme.palette.getColor(theme.client.table.common.border)}`,
      },
      '.MuiDataGrid-cellContent': {
        overflow: 'visible',
        whiteSpace: 'normal',
      },
    },
  };
};
